var path = 'src/app/patients/nephrectomies/nephrectomies.html';
var html = "<h1 class=page-header>Nephrectomies</h1> <div nephrectomies-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/nephrectomies/nephrectomies.html
 ** module id = 543
 ** module chunks = 0
 **/